import { render, staticRenderFns } from "./ActivitySkeleton.vue?vue&type=template&id=28a65b27"
import script from "./ActivitySkeleton.vue?vue&type=script&lang=js"
export * from "./ActivitySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports